import { formatDateTime } from "@clipboard-health/date-time";
import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { parseISO } from "date-fns";

import { type ScoreLedgerEntry } from "../../api/useShiftScoreLedger";

interface ScoreLedgerItemProps {
  readonly entry: ScoreLedgerEntry;
}

export function ScoreLedgerItem({ entry }: ScoreLedgerItemProps) {
  const isPositive = entry.adjustment >= 0;
  const adjustmentPrefix = isPositive ? "+" : "";

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={(theme) => ({
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.shape.borderRadius,
      })}
    >
      <Stack spacing={0.5}>
        <Text bold variant="body2">
          {entry.displayAction}
        </Text>
        <Text variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary })}>
          {formatDateTime(parseISO(entry.createdAt))}
        </Text>
      </Stack>
      <Text
        bold
        variant="body2"
        sx={(theme) => ({
          color: isPositive ? theme.palette.success.main : theme.palette.error.main,
        })}
      >
        {adjustmentPrefix}
        {entry.adjustment} pts
      </Text>
    </Stack>
  );
}
